var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative", "z-index": "999" } },
    [
      _c("header", [
        _vm.processing
          ? _c("div", { staticClass: "loading" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        !_vm.user && _vm.showPublicHeader
          ? _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row d-flex align-items-center mob-head" },
                [
                  !_vm.showHeader
                    ? _c("div", { staticClass: "col-lg-3 col-md-3 col-3" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm._m(2)
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showHeader && !_vm.user
                    ? _c(
                        "div",
                        { staticClass: "col-lg-6 col-md-3 text-center" },
                        [
                          _c(
                            "ul",
                            {
                              staticClass: "desktop-main-menu",
                              class: [
                                _vm.isDrawerOpen ? "active" : "",
                                _vm.isMobile || _vm.isIpad
                                  ? "p-user-sec-mobile"
                                  : ""
                              ]
                            },
                            [
                              _vm._m(3),
                              _vm._v(" "),
                              _vm.window.width >= 1025
                                ? _c(
                                    "li",
                                    {
                                      staticClass:
                                        "headerMobile-ipad header-deks"
                                    },
                                    [_vm._m(4), _vm._v(" "), _vm._m(5)]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isMobile || _vm.isIpad
                                ? _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:;" },
                                        on: {
                                          click: function($event) {
                                            _vm.showCauses = !_vm.showCauses
                                          }
                                        }
                                      },
                                      [
                                        _vm._v("Causes"),
                                        _c("i", {
                                          staticClass: "fas fa-caret-down"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass: "mobile-submenu",
                                        class: { show: _vm.showCauses }
                                      },
                                      [
                                        _vm._m(6),
                                        _vm._v(" "),
                                        _vm._m(7),
                                        _vm._v(" "),
                                        _vm._m(8)
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.window.width >= 1025
                                ? _c(
                                    "li",
                                    {
                                      staticClass:
                                        "headerMobile-ipad header-deks"
                                    },
                                    [
                                      _vm._m(9),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "sub-menu",
                                          class: [
                                            _vm.isDrawerOpen ? "active" : "",
                                            _vm.isMobile || _vm.isIpad
                                              ? "mob-sub"
                                              : ""
                                          ]
                                        },
                                        [
                                          _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "business-listing"
                                                    }
                                                  }
                                                },
                                                [_vm._v("B1G1 MEMBERS")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._m(10),
                                          _vm._v(" "),
                                          _vm._m(11),
                                          _vm._v(" "),
                                          _vm._m(12),
                                          _vm._v(" "),
                                          _vm._m(13)
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isMobile || _vm.isIpad
                                ? _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:;" },
                                        on: {
                                          click: function($event) {
                                            return _vm.showCommunityTab()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v("Community"),
                                        _c("i", {
                                          staticClass: "fas fa-caret-down"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass: "mobile-submenu",
                                        class: { show: _vm.showCommunity }
                                      },
                                      [
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: {
                                                    name: "business-listing"
                                                  }
                                                }
                                              },
                                              [_vm._v("B1G1 MEMBERS")]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._m(14),
                                        _vm._v(" "),
                                        _vm._m(15),
                                        _vm._v(" "),
                                        _vm._m(16),
                                        _vm._v(" "),
                                        _vm._m(17)
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._m(18)
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.user
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-lg-3 col-md-6 col-sm-6 col-8 text-right mob-right-sec"
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "login-btn",
                              attrs: { to: { name: "login" } }
                            },
                            [_vm._v("Login")]
                          ),
                          _vm._v(" "),
                          _vm._m(19),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle",
                              class: _vm.isDrawerOpen ? "change" : "",
                              on: {
                                click: function($event) {
                                  return _vm.openMenuDrawer()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "bar1" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "bar2" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "bar3" })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showHeader
          ? _c(
              "div",
              {
                staticClass: "container",
                staticStyle: { position: "relative" }
              },
              [
                _c(
                  "div",
                  { staticClass: "row d-flex align-items-center" },
                  [
                    _c("div", { staticClass: "col-md-3 col-5 d-none" }, [
                      _c("img", {
                        staticClass: "d-logo",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          alt: "alt",
                          src: "/static/front/images/b1g1-logo-blue.png",
                          height: "66.45px",
                          width: "174px"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$router.push({ name: "impact" })
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "m-logo",
                        staticStyle: { cursor: "pointer" },
                        attrs: {
                          alt: "alt",
                          src: "/static/front/images/b1g1-light-widget.png"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$router.push({ name: "impact" })
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5 col-5" },
                      [
                        _c(
                          "div",
                          { staticClass: "mobile-menu-list" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "toggle",
                                class: _vm.isDrawerOpen ? "change" : "",
                                on: { click: _vm.toggleMenu }
                              },
                              [
                                _c("div", { staticClass: "bar1" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "bar2" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "bar3" })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "RouterLink",
                              {
                                attrs: { to: "/" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.closeMenu.apply(null, arguments)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "businessLogo",
                                  attrs: {
                                    src:
                                      "/static/front/images/menu-images/b1g1-logo.svg",
                                    alt: "alt"
                                  }
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "personalLogo",
                                  attrs: {
                                    src:
                                      "/static/front/images/menu-images/b1g1-logo-2.svg",
                                    alt: "alt"
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("search", { attrs: { user: _vm.user } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.user && _vm.showRoutes
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-md-7 col-7 d-flex align-items-center justify-content-end"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "noti" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticStyle: { "margin-right": "2.5px" },
                                    attrs: {
                                      to: { name: "giving-cart" },
                                      rel: "noopener"
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.closeCart.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("aside", { staticClass: "cart" }, [
                                      _c("div", [
                                        _vm.getCartCount > 0
                                          ? _c(
                                              "em",
                                              { attrs: { id: "cartnumber" } },
                                              [_vm._v(_vm._s(_vm.getCartCount))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("img", {
                                          attrs: {
                                            src:
                                              "/static/front/images/menu-images/basket-icon.svg",
                                            alt: ""
                                          }
                                        })
                                      ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "aside",
                                  {
                                    staticClass: "notifation",
                                    staticStyle: { margin: "3px 0 0" },
                                    attrs: { id: "myDiv2" }
                                  },
                                  [
                                    _c("div", [
                                      _vm.cntNotification
                                        ? _c(
                                            "em",
                                            {
                                              attrs: {
                                                id: "notificationnumber"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.cntNotification)
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/front/images/menu-images/cart.svg",
                                          alt: ""
                                        },
                                        on: { click: _vm.closeNoti }
                                      })
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.user
                              ? _c(
                                  "div",
                                  {
                                    class:
                                      _vm.user.account === "company"
                                        ? "user-sec"
                                        : "user-sec p-user-sec"
                                  },
                                  [
                                    _vm.user.account === "company"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "notification-wrapper"
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyName.charAt(0)
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "h4",
                                              {
                                                staticStyle: { width: "155px" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.companyName.length > 25
                                                      ? _vm.companyName.substr(
                                                          0,
                                                          25
                                                        ) + "..."
                                                      : _vm.companyName
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.user.account !== "company"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "notification-wrapper"
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.user.first_name.charAt(0)
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "h4",
                                              {
                                                staticStyle: { width: "155px" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.user.first_name.length >
                                                      25
                                                      ? _vm.user.first_name.substr(
                                                          0,
                                                          25
                                                        ) + "..."
                                                      : _vm.user.first_name
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.user.account === "company"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "notification-wrapper"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v("Business Account")
                                            ]),
                                            _vm._v(" "),
                                            _c("ul", [
                                              _vm.isAdminLogin
                                                ? _c("li", [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.adminAccount()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/front/images/drop-down-icon/admin-account.svg",
                                                            alt: ""
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "Back to Admin Account"
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.user.user_business.company_id
                                                ? _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "business.company.profile"
                                                            }
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickRightMenuClose()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/front/images/drop-down-icon/company-profile.svg",
                                                              alt: ""
                                                            }
                                                          }),
                                                          _vm._v(
                                                            " Company Profile"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.user.user_business &&
                                              _vm.user.user_business.is_admin &&
                                              _vm.user.user_business
                                                .is_business === 0
                                                ? _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "billing-details"
                                                            }
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickRightMenuClose()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/front/images/drop-down-icon/billing.svg",
                                                              alt: ""
                                                            }
                                                          }),
                                                          _vm._v("Billing")
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.isDowngradeUser
                                                ? _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "impact-reminders"
                                                            }
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickRightMenuClose()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/front/images/drop-down-icon/alarm-clock.svg",
                                                              alt: ""
                                                            }
                                                          }),
                                                          _vm._v(
                                                            "Your Impact Reminders"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.user.id === _vm.compnayOwnerId
                                                ? _c(
                                                    "li",
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "reset-password"
                                                            }
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickRightMenuClose()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/front/images/drop-down-icon/check.svg",
                                                              alt: ""
                                                            }
                                                          }),
                                                          _vm._v(
                                                            "Reset Password"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("li", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.logout()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/front/images/drop-down-icon/log-out.svg",
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v("Log Out")
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.user.user_business.company_id
                                                ? _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "switch-to-personal"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "pointer",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.personalAccount()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Switch to Personal Account"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              { staticClass: "d-none" },
                                              [
                                                _vm.isAdminLogin
                                                  ? _c("li", [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "pointer",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.adminAccount()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Back to Admin Account"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .company_id
                                                  ? _c("li", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "javascript:void(0)"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.personalAccountProfile()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Personal Profile & Settings"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "impact.history"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Impact History"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.id ===
                                                _vm.compnayOwnerId
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "reset-password"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Reset Password"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .company_id
                                                  ? _c("li", [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "pointer",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.personalAccount()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Switch to Personal Account"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      {
                                                        staticClass: "menu-ti"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  Company\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "business.company.profile"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Company Profile"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _vm.company &&
                                                        _vm.company
                                                          .token_management_access ===
                                                          "1"
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to: {
                                                                    name:
                                                                      "token-management"
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.clickRightMenuClose()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Token Management"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "impact.history"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Impact History"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _vm.company &&
                                                        _vm.company
                                                          .token_management_access ===
                                                          "1"
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to: {
                                                                    name:
                                                                      "token-management"
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.clickRightMenuClose()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Token Management\n                  "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.company &&
                                                        _vm.company
                                                          .token_management_access ===
                                                          "0"
                                                          ? _c(
                                                              "a",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "tooltip",
                                                                    rawName:
                                                                      "v-tooltip.top",
                                                                    value: {
                                                                      content:
                                                                        "Upgrade to access",
                                                                      class:
                                                                        "normal-tooltip"
                                                                    },
                                                                    expression:
                                                                      "{ content: 'Upgrade to access', class: 'normal-tooltip' }",
                                                                    modifiers: {
                                                                      top: true
                                                                    }
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "header-menu-disable"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Token Management"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "team-accounts-management"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Team Accounts Management\n                  "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.user.user_business &&
                                                _vm.user.user_business
                                                  .is_admin &&
                                                _vm.user.user_business
                                                  .is_business === 0
                                                  ? _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                name:
                                                                  "billing-details"
                                                              }
                                                            },
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.clickRightMenuClose()
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Billing")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("li", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.logout()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-sign-out-alt"
                                                      }),
                                                      _vm._v("Log Out")
                                                    ]
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.user.account !== "company"
                                      ? _c("div", [
                                          _c("p", [_vm._v("Personal Account")]),
                                          _vm._v(" "),
                                          _c("ul", [
                                            _vm.isAdminLogin
                                              ? _c("li", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "pointer",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.adminAccount()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/static/front/images/drop-down-icon/admin-account.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "Back to Admin Account"
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name:
                                                          "business.personal.profile"
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickRightMenuClose()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/front/images/drop-down-icon/company-profile.svg",
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "Personal Profile & Settings\n                  "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name: "impact.history"
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickRightMenuClose()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/front/images/drop-down-icon/alarm-clock.svg",
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v("Impact History")
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            !_vm.isDowngradeUser
                                              ? _c(
                                                  "li",
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "impact-reminders"
                                                          }
                                                        },
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.clickRightMenuClose()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/front/images/drop-down-icon/alarm-clock.svg",
                                                            alt: ""
                                                          }
                                                        }),
                                                        _vm._v(
                                                          "Your Impact Reminders"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name:
                                                          "business.personal.reset-password"
                                                      }
                                                    },
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.clickRightMenuClose()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          "/static/front/images/drop-down-icon/check.svg",
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm._v("Reset Password")
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.logout()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        "/static/front/images/drop-down-icon/log-out.svg",
                                                      alt: ""
                                                    }
                                                  }),
                                                  _vm._v("Log Out")
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.user.user_business &&
                                            _vm.user.user_business.company_id &&
                                            parseInt(
                                              _vm.user.user_business.is_admin
                                            )
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "switch-to-personal"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.companyAccount()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Switch to Business Account"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._m(20)
                                  ]
                                )
                              : _c("div", { staticClass: "user-sec" }, [
                                  _c("span", [_vm._v("G")]),
                                  _vm._v(" "),
                                  _c("h4", [
                                    _vm._v("Guest "),
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "white",
                                          "font-size": "18px"
                                        },
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            return _vm.logout()
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-sign-out-alt"
                                        })
                                      ]
                                    )
                                  ])
                                ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dot-cion-menu",
                                on: { click: _vm.toggleRightMenu }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "/static/front/images/drop-down-icon/menu-dots-icon.svg",
                                    alt: "alt"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.user && !_vm.showRoutes
                      ? _c("headerDisable", {
                          staticClass:
                            "col-md-7 col-7 d-flex align-items-center justify-content-end"
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showNotification
                  ? _c(
                      "div",
                      {
                        staticClass: "notification-blog",
                        attrs: { id: "myDiv" }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm._m(21),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-md-6 col-xl-6 text-right d-flex align-items-center justify-content-end"
                            },
                            [
                              _vm.notifications.length > 0
                                ? _c(
                                    "button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.readNotification(0, null)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/front/images/menu-images/approve-tick.svg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v("MARK ALL AS READ")
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.notifications.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "noti_scroll",
                                on: { scroll: _vm.handleScroll }
                              },
                              _vm._l(_vm.notifications, function(
                                notification,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class:
                                      notification.status === "1"
                                        ? "row readNoti"
                                        : "row unreadNoti",
                                    attrs: { data: notification.id },
                                    on: {
                                      click: function($event) {
                                        return _vm.readNotification(
                                          1,
                                          notification
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-11 notification-bulets"
                                      },
                                      [
                                        notification.broadcast_notification
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "notification-title"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      notification
                                                        .broadcast_notification
                                                        .title
                                                    ) +
                                                    "\n                "
                                                ),
                                                notification &&
                                                notification.broadcast_notification &&
                                                notification
                                                  .broadcast_notification
                                                  .external_link !== ""
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            notification
                                                              .broadcast_notification
                                                              .external_link,
                                                          target: "_blank"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.externalLink(
                                                              $event
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-external-link-alt",
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            "padding-left":
                                                              "0px"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "noti-date" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.getDateFormat(
                                                    notification.notification_date
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "notification-body" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  notification
                                                    .broadcast_notification
                                                    .message_body
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "trash-alt-wrapper" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "white-btn",
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteNotification(
                                                  notification
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-trash-alt"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _c("div", { staticClass: "row" }, [_vm._m(22)])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showHeader && _vm.bannerData
          ? _c("div", { staticClass: "blue-strip-text" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.bannerData.title) } })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "overly-close",
        on: { click: _vm.toggleRightMenu }
      }),
      _vm._v(" "),
      _c("RouterLink", {
        staticClass: "overly-close",
        attrs: { to: "" },
        nativeOn: {
          click: function($event) {
            return _vm.closeMenu.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _vm.user && _vm.showRoutes
        ? _c("menuCustom", {
            attrs: {
              partner_level: _vm.partner_level,
              user: _vm.user,
              isHivePartner: _vm.isHivePartner,
              companyName: _vm.companyName,
              totalImpacts: _vm.totalImpacts
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        { attrs: { name: "gift", height: "auto", scrollable: false } },
        [
          _c("div", { staticClass: "toast-title" }, [_vm._v("Gifted")]),
          _vm._v(" "),
          _c("div", { staticClass: "toast-message" }, [
            _vm._v(
              "A special Giving Credit of US $100.00 has been added to your account!"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "load" }, [
      _c("hr"),
      _c("hr"),
      _c("hr"),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "loadback" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.b1g1.com/",
          target: "_blank",
          rel: "noopener"
        }
      },
      [
        _c("img", {
          staticClass: "d-logo",
          staticStyle: { cursor: "pointer" },
          attrs: {
            src: "/static/front/images/b1g1-logo-blue.png",
            alt: "alt",
            height: "66.45px",
            width: "174px"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.b1g1.com/",
          target: "_blank",
          rel: "noopener"
        }
      },
      [
        _c("img", {
          staticClass: "m-logo",
          attrs: {
            src: "/static/front/images/b1g1-light-widget.png",
            alt: "alt"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: { href: "https://b1g1.com/the-b1g1-model", target: "_blank" }
        },
        [_vm._v("HOW IT WORKS")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#" } }, [
      _vm._v("Causes\n                "),
      _c("i", { staticClass: "fas fa-caret-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "sub-menu" }, [
      _c("li", [
        _c(
          "a",
          {
            attrs: { href: "https://b1g1.com/b1g1-projects", target: "_blank" }
          },
          [_vm._v("B1G1 Projects")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          { attrs: { href: "https://b1g1.com/impacts", target: "_blank" } },
          [_vm._v("THE IMPACTS")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "https://b1g1.com/sustainable-development-goals",
              target: "_blank"
            }
          },
          [_vm._v("SUSTAINABLE DEVELOPMENT GOALS")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://b1g1.com/b1g1-projects", target: "_blank" } },
        [_vm._v("B1G1 Projects")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://b1g1.com/impacts", target: "_blank" } },
        [_vm._v("THE IMPACTS")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://b1g1.com/sustainable-development-goals",
            target: "_blank"
          }
        },
        [_vm._v("SUSTAINABLE DEVELOPMENT\n                  GOALS")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "#" } }, [
      _vm._v("Community"),
      _c("i", { staticClass: "fas fa-caret-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://b1g1.com/advocates", target: "_blank" } },
        [_vm._v("ADVOCATES")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://b1g1.com/the-team", target: "_blank" } },
        [_vm._v("THE TEAM")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://b1g1.com/careers", target: "_blank" } },
        [_vm._v("WORK WITH B1G1")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: { href: "https://b1g1.com/events/overview", target: "_blank" }
        },
        [_vm._v("EVENTS")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://b1g1.com/advocates", target: "_blank" } },
        [_vm._v("ADVOCATES")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://b1g1.com/the-team", target: "_blank" } },
        [_vm._v("THE TEAM")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { href: "https://b1g1.com/careers", target: "_blank" } },
        [_vm._v("WORK WITH B1G1")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: { href: "https://b1g1.com/events/overview", target: "_blank" }
        },
        [_vm._v("EVENTS")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "https://blog.b1g1.com/", target: "_blank" } }, [
        _vm._v("Blog")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "b-btn red-btn" }, [
      _c(
        "a",
        {
          staticClass: "login-btn",
          staticStyle: {
            "text-transform": "uppercase",
            margin: "0 !important"
          },
          attrs: { href: "https://b1g1.com/join-us", target: "_blank" }
        },
        [_vm._v("Join Us")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "fas fa-caret-down" }, [
      _c("img", {
        attrs: {
          src: "/static/front/images/menu-images/down-arrow.svg",
          alt: "alt"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 col-md-6 col-xl-6" }, [
      _c("h3", { staticStyle: { margin: "0" } }, [_vm._v("Your Notifications")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 readNoti" }, [
      _c("div", { staticClass: "notification-body" }, [
        _vm._v("\n              No messages to display\n            ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7a22808", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7a22808","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/Header.vue
// module id = null
// module chunks = 